import { useState, useEffect } from 'react'
import { ItemList, ListItem } from 'schema-dts'
import { helmetJsonLdProp } from 'react-schemaorg'
import { useMatch } from 'react-router-dom'
import { useShop } from 'shop/hooks'
import { Helmet } from 'react-helmet-async'
import { createOffers, trimUrl } from './utils'
import { CategoryProduct } from '../Shop/Categories'

interface Props {
  products: CategoryProduct[]
}

export const ProductListMeta = ({ products }: Props) => {
  const { partner, currentPartnerStore } = useShop()
  const { name: storeName } = currentPartnerStore || {}
  const { seo, name: partnerName } = partner || {}

  const [modalMode, setModalMode] = useState(false)

  const baseUrl = trimUrl(window.location.origin + window.location.pathname)
  const match = useMatch('/store/:store/:product')

  useEffect(() => {
    if (match) {
      setModalMode(true)
    } else {
      setModalMode(false)
    }
  }, [match])

  if (!seo?.enabled || modalMode) {
    return <></>
  }

  const itemList = products.map((product, index) => {
    return {
      '@type': 'ListItem' as const,
      position: index,
      item: {
        '@context': 'https://schema.org',
        '@type': 'Product' as const,
        name: product.name,
        url: baseUrl + `/${product.slug}`,
        image: product.images.map((image) => image.standard),
        description: product.description || '',
        sku: product.id,
        brand: {
          '@type': 'Brand' as const,
          name: partnerName
        },
        offers: createOffers(
          product,
          `${partnerName} ${storeName}`,
          baseUrl + `/${product.slug}`
        )
      }
    }
  }) as ListItem[]

  return (
    <Helmet
      script={[
        helmetJsonLdProp<ItemList>({
          '@context': 'https://schema.org',
          '@type': 'ItemList' as const,
          itemListElement: itemList
        })
      ]}
    />
  )
}
